import { IContact } from './../../services/contacts.service';
import { IAuthUser } from './../../authsettings/services/authusers.service';
import { ITask, TasksService, ITeam } from "../../services";
import { IAccount, AccountsService } from '../../services/accounts.service';
import { IEmployee } from '../../services/employees.service';
import { ILocation } from '../../services/location.service';

interface IResolve {
    task: ITask;
    users: any;
    accounts: any;
    contacts: any;
    employees: any;
    taskStatuses: any;
}

class TaskItemBasicController {

    private resolve: IResolve;
    private task: ITask;
    private users: IAuthUser[];
    private accounts: IAccount[];
    private locations: ILocation[];
    private teams: ITeam[];
    private contacts: IContact[];
    private employees: IEmployee[];
    private taskStatuses: any;

    constructor(
        private TasksService: TasksService,
        private AccountsService: AccountsService,
        private $state: ng.ui.IStateService
    ) {
        'ngInject';
    }


    public $onInit = () => {    
        this.task = this.resolve.task;
        this.users = this.resolve.users;
        this.accounts = this.resolve.accounts;
        this.contacts = this.resolve.contacts;
        this.employees = this.resolve.employees;
        this.taskStatuses = this.resolve.taskStatuses;
    }

    public save = () => {
        this.setUserName();

        if (this.task.id != undefined) {
            this.TasksService.put(this.task.id, this.task).then((task: ITask) => {
                 this.closeModal();
            });
        } else {
            this.TasksService.post(this.task).then((task: ITask) => {
                this.$state.go('^', { 'id': task.id });
            });
        }
    }

    setUserName() {
        var selectedUser = this.users.find(u => u.id === this.task.userId);
        if (selectedUser) {
            this.task.userName = selectedUser.userName;
        } else {
            this.task.userName = null;
        }
    }

    accountSelected() {
        this.AccountsService.getChild(this.task.accountId, 'locations').then((result: any) => {
            this.locations = result;
            // console.log(this.locations);
        });
    }

    locationSelected() {
        this.teams = this.locations.find(item => item.id === this.task.locationId).teams;
    }

    private closeModal() {
        this.$state.go('^', {}, { reload: true });
    }
}

export const taskItemBasicComponent = { 
    bindings: {
        resolve : "<",
        close: "&"
    },
    controller: TaskItemBasicController,
    template: require('./task.item.basic.html')
};



// WEBPACK FOOTER //
// ./src/app/modules/tasks/task.item.basic.component.ts